import { Button, CircularProgress } from '@mui/material'
import { QuizButtonProps } from '../types'

export default function QuizButton(props: QuizButtonProps) {
    return (
        <>
            <Button
                id={props.ID}
                variant={props.variant}
                disabled={props.disabled}
                onClick={() => props.Action()}
            >
                {props.loading ?
                    <span>
                        Loading
                        <CircularProgress color="inherit" size={'1em'} sx={{ marginLeft: '1em' }} />
                    </span> :
                    <>{props.label}</>
                }
            </Button>
        </>
    )
}